import { Flex, Image } from "@chakra-ui/react"
import { getProjectsIconById } from "@root/utils/chatHelper"
import { WEB_PROJECTS } from "@root/webConstants"
import { useTranslation } from "react-i18next"
import { CustomText } from "../common/components"

export const HistoryItemProjectChip = ({ pid }: any) => {
    const { t } = useTranslation("common")

    if (!pid) {
        return null
    }

    const historyTextIndicator = () => {
        let text: string = ''
        switch (pid) {
            case WEB_PROJECTS.RISK_CHECKER.id:
                text = t('translate.construction')
                break;
            case WEB_PROJECTS.CON_GPT.id:
                text = t('translate.riskAnalaysis')

                break;
            case WEB_PROJECTS.DOAZ_GPT.id:
                text = t('translate.DoazGPT')

                break;
        }
        return text
    }

    return (
        <Flex
            padding={'6px'}
            alignItems={'center'}
            gap={'8px'}
            maxHeight={'28px'}
            border={'1px solid'}
            borderRadius={'4px'}
            borderColor={'gray.border'}
            bgColor={'theme.white'}
        >
            <Image
                maxH={'16px'}
                my={'auto'}
                maxW={'16px'}
                src={getProjectsIconById(pid)}
            />
            <CustomText
                color={'theme.gray.500'}
                text={historyTextIndicator()}
            />
        </Flex>
    )
}
